<template>
  <CardPrimary :style="cardStyle">
    <div :style="headerContainerStyle">
      <HeaderMediumPrimary :truncate="true">
        All Skills Data
      </HeaderMediumPrimary>
      <div :style="hideButtonContainerStyle"
           @click="$emit('hide-panel')">
        x
      </div>
    </div>
    <div v-if="dataLoaded"
         :style="rowsContainerStyle">
      <div v-for="(row, index) in rows" :key="index"
           :style="rowContainerStyle">
        <div :style="labelStyle">
          {{ row.label }}
        </div>
        <div :style="valueStyle">
          {{ row.value }}
        </div>
      </div>
    </div>
    <div :style="checkboxesContainerStyle">
      <input type="checkbox" v-model="enableAutoCameraOrbit" />
      <span :style="checkboxLabelStyle">
        Spin Skills Graph
      </span>
    </div>
    <div :style="buttonContainerStyle">
      <ButtonPrimary @click="() => {}">
        Download CSV
      </ButtonPrimary>
    </div>
  </CardPrimary>
</template>

<script>
  import ButtonPrimary from "@modules/button/button-primary"
  import CardPrimary from '@modules/card/card-primary'
  import HeaderMediumPrimary from '@modules/text/header-medium-primary'
  import { FontStyle, Layout } from '@js/styles'
  import { mapState } from 'vuex'

  export default {
    name: 'AggregatedSkillsPanel',
    components: {
      ButtonPrimary,
      CardPrimary,
      HeaderMediumPrimary,
    },
    data: function () {
      return {
        buttonContainerStyle: {
          display: 'none',
        },
        cardStyle: {
          minWidth: '200px',
          maxWidth: '240px',
          padding: `${Layout.space.sm} ${Layout.space.md}`,
        },
        checkboxLabelStyle: {
          fontSize: FontStyle.size.md,
          fontWeight: FontStyle.weight.xl,
          margin: `0 0 0 ${Layout.space.sm}`,
        },
        checkboxesContainerStyle: {
          display: 'flex',
          justifyContent: 'flex-start',
          margin: `${Layout.space.md} 0 `,
          width: '100%',
        },
        enableAutoCameraOrbit: true,
        headerContainerStyle: {
          alignItems: 'center',
          display: 'flex',
          justifyContent: 'space-between',
          width: '100%',
        },
        hideButtonContainerStyle: {
          cursor: 'pointer',
        },
        labelStyle: {
          fontSize: FontStyle.size.md,
          fontWeight: FontStyle.weight.md,
        },
        rowContainerStyle: {
          alignItems: 'center',
          display: 'flex',
          justifyContent: 'space-between',
          margin: `${Layout.space.sm} 0 0 0`,
          width: '100%',
        },
        rowsContainerStyle: {
          display: 'flex',
          flexDirection: 'column',
          margin: `${Layout.space.sm} 0 0 0`,
          width: '100%',
        },
        valueStyle: {
          fontSize: FontStyle.size.md,
          fontWeight: FontStyle.weight.xl,
        },
      };
    },
    mounted: async function () {
      try {
        if (!this.tenantUserDiagnoseLoaded) {
          await this.$store.dispatch('tenantUserDiagnose/fetch');
        }
        if (!this.tenantDiagnoseLoaded) {
          await this.$store.dispatch('tenantDiagnose/fetch');
        }
      } catch (error) {
        console.error(error);
      }
    },
    computed: {
      ...mapState({
        tenantUserCount: state => state.tenantDiagnose.data.tenantUserCount,
        tenantUserSkillCount: state => state.tenantDiagnose.data.tenantUserSkillCount,
        tenantDiagnoseLoaded: state => state.tenantDiagnose.initialized,
        tenantUserDiagnoseLoaded: state => state.tenantUserDiagnose.initialized,
      }),
      dataLoaded: function () {
        return this.tenantUserDiagnoseLoaded && this.tenantDiagnoseLoaded;
      },
      rows: function () {
        return [
            { label: 'Total users', value: this.tenantUserCount, },
            { label: 'Total skills', value: this.tenantUserSkillCount, },
            { label: 'Skills per user', value: this.skillsCountPerUser, },
        ];
      },
      skillsCountPerUser: function () {
        return this.dataLoaded ? (this.tenantUserSkillCount / this.tenantUserCount).toFixed(1) : 0;
      },
    },
    watch: {
      enableAutoCameraOrbit: function (newVal, oldVal) {
        if (newVal) {
          this.$emit('enable-auto-camera-orbit');
        } else {
          this.$emit('disable-auto-camera-orbit');
        }
      },
    },
  };
</script>
